import {BaseWidget} from "./BaseWidget";

export class PasswordWidget extends BaseWidget {
    createElement(style) {
        return $(`<input class="w-100" type='password' ${style} id="${this.elementId}" autocomplete="new-password"  nid="${this.id}">`);
    }
}